import {
  IconCopy,
  IconDownload,
  IconLock,
  IconPencil,
  IconTrash,
} from "@tabler/icons-react";
// @ts-expect-error pure js
import { DocType } from "../../utils/constants/documents";
import DropdownMenu from "../UI/DropdownMenu.tsx";
import useDocumentDownload from "../../hooks/use-document-download";
import type { Balance } from "../../models/balance";
import { BalanceDomain } from "../../utils/constants/balances";
import type { ReactNode } from "react";

interface BalanceRowActionsProps {
  balance: Balance;
  onEdit: () => void;
  onDuplicate: () => void;
  onDelete: () => void;
  children?: ReactNode;
}

export default function BalanceRowActions({
  balance,
  onEdit,
  onDuplicate,
  onDelete,
  children,
}: BalanceRowActionsProps) {
  const isGroupedBalance = balance.balances && balance.balances.length > 0;
  const isBalanceFromSplit =
    balance.correlation_id &&
    !isGroupedBalance &&
    balance.domaine !== BalanceDomain.TENANT;
  const isProtected = !!balance.is_protected_by_invoice;

  const justificatifId =
    isGroupedBalance && balance.balances ? balance.balances[0].id : balance.id;
  const { downloadHandler } = useDocumentDownload({
    documentId: justificatifId,
    file: balance.file,
    doctype: DocType.JUSTIFICATIF_BALANCE,
    save: true,
  });

  return (
    <>
      {isProtected ? (
        <DropdownMenu.Item
          icon={IconLock}
          label="Édition et suppression impossibles (facture éditée)"
          disabled
        />
      ) : (
        <>
          <DropdownMenu.Item
            requiresWrite
            icon={IconPencil}
            label="Éditer l'opération"
            onClick={onEdit}
          />
          <DropdownMenu.Item
            requiresWrite
            icon={IconCopy}
            label="Dupliquer"
            onClick={onDuplicate}
          />
        </>
      )}
      {children}
      {balance.file && (
        <DropdownMenu.Item
          icon={IconDownload}
          label="Télécharger le justificatif"
          onClick={downloadHandler}
        />
      )}
      {!isProtected && !isBalanceFromSplit && (
        <DropdownMenu.Item
          requiresWrite
          icon={IconTrash}
          label="Supprimer"
          variant="danger"
          onClick={onDelete}
        />
      )}
    </>
  );
}
